






import Vue from 'vue';

export default Vue.extend({
  name: "ThreatreMain2d",
  data: () => {
    return {};
  },
});
